import InboxOnlyMembersAPI from '../../api/inboxOnlyMembers';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
  },
};

export const types = {
  SET_INBOX_ONLY_MEMBERS_UI_FLAG: 'SET_INBOX_ONLY_MEMBERS_UI_FLAG',
  SET_INBOX_ONLY_MEMBERS: 'SET_INBOX_ONLY_MEMBERS',
};

export const getters = {
  getInboxOnlyMembers: $state => (inboxId, teamId = null) => {
    // Crear clave que incluya team_id si existe
    const key = teamId ? `${inboxId}_team_${teamId}` : inboxId;
    const allMembers = $state.records[key] || [];
    const verifiedMembers = allMembers.filter(record => record.confirmed);
    return verifiedMembers;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, { inboxIds, teamId = null }) {
    commit(types.SET_INBOX_ONLY_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload },
      } = await InboxOnlyMembersAPI.get(inboxIds, teamId);
      
      // Crear clave que incluya team_id si existe
      const key = teamId ? `${inboxIds.join(',')}_team_${teamId}` : inboxIds.join(',');
      
      commit(types.SET_INBOX_ONLY_MEMBERS, {
        inboxId: key,
        members: payload,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_INBOX_ONLY_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_INBOX_ONLY_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_INBOX_ONLY_MEMBERS]: ($state, { inboxId, members }) => {
    $state.records = {
      ...$state.records,
      [inboxId]: members,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
